export function bustUrlCache(urlString: string) {
  const url = new URL(urlString, window.location.origin);
  url.searchParams.set('t', Date.now().toString());
  return url.toString();
}
